import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class TokenTransferService {
    private cpsUrl = environment.CPS_URL;
    private cpsOrigin = environment.CPS_ORIGIN; 

    sendTokensToCps(accessToken: string, refreshToken: string): void {
        if (!accessToken || !refreshToken) {
          return;
        }
    
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = this.cpsUrl;
    
        iframe.onload = () => {
          setTimeout(() => {
            iframe.contentWindow?.postMessage(
              { accessToken, refreshToken },
              this.cpsOrigin
            );
          }, 1000);
        };
    
        document.body.appendChild(iframe);
      }
}